import { http } from '../../../../api/http';
import type { ComprobanteElectronico } from '../types/comprobante.types';

export class ComprobanteElectronicoService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/comprobante-electronico',
  };

  public static async getAll(): Promise<ComprobanteElectronico[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching comprobantes:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<ComprobanteElectronico> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching comprobante:', error);
      throw error;
    }
  }

  public static async enviar(idFactura: number): Promise<ComprobanteElectronico> {
    try {
      const response = await http.post(`${this.ENDPOINTS.BASE}/enviar/${idFactura}`);
      return response.data;
    } catch (error) {
      console.error('Error enviando comprobante:', error);
      throw error;
    }
  }

  public static async consultarEstado(id: number): Promise<ComprobanteElectronico | null> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/consultar-estado/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error consultando estado:', error);
      return null;
    }
  }
}
